<template>
  <div class="w-full">
    <div 
      class="ProgressBar w-full"
      :class="{'ProgressBar__Full': isOverLimit}"
    >
      <div class="ProgressBar__Value" :style="barStyle" />
    </div>
    <span 
      v-if="isOverLimit && warning"
      class="ProgressBar__Warning"
    >
      <aw-icon 
        icon="error" 
        class="w-4 h-4"
      />
      {{ warning }}
    </span>
    <slot 
      name="options"
      v-if="isOverLimit"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    warning: {
      type: String,
      default: null,
    }
  },
  computed: {
    isOverLimit() {
      return this.value >= this.max
    },
    barStyle() {
      let width = 0
      if (this.value > this.max) {
        width = 100
      } else if (this.value > 0) {
        width = this.value / this.max * 100
      }

      return {
        width: width + '%'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.ProgressBar {
  @apply h-2 rounded-full;
  @apply bg-gray-300;
  @apply my-2;
  //@apply rounded-r-full;
  
  &__Value {
    @apply h-2;
    @apply bg-bc-blue;
    @apply rounded-l-full;
  }

  &__Full {
    .ProgressBar__Value {
      @apply bg-red-500;
      @apply rounded-full;
    }
  }
}

.ProgressBar__Warning {
  @apply block mt-1 mx-auto text-xs text-red-500 text-center;
}
</style>
